import { formatDistanceToNow } from "date-fns";

// The API stores UTC but serializes without a zone suffix, so treat bare timestamps as UTC.
export const parseUtc = (value: string): Date =>
  new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`);

export const postedAgo = (value: string): string => {
  const date = parseUtc(value);
  // Guard against small clock skew producing "in a few seconds".
  const clamped = date.getTime() > Date.now() ? new Date() : date;
  return `Posted ${formatDistanceToNow(clamped, { addSuffix: true })}`;
};
